/**
 * Vendor stylesheets the appspace-ui components render against.
 *
 * appspace-ui splits its CSS the way it splits its JS: asui-dist.css holds its
 * own component styles, components/vendor.css held the third-party styles those
 * components are built on. vendor.css is no longer loaded -- it was a second
 * full copy of Bootstrap (.btn, .navbar, body, .container) that landed after
 * the app's own bootstrap.css and overrode the global layout -- so every
 * stylesheet it carried that this app still needs has to come from its own
 * package instead.
 *
 * Losing one is silent: webpack compiles, every test passes, and the damage
 * only shows on a rendered page. Dropping vendor.css took 1,246 Froala rules
 * with it and the rich-text toolbar lost its layout, which is why each entry
 * below pairs the stylesheet with a selector that must survive in it. See
 * vendorStyles.test.js.
 *
 * Order matters: these load before asui-dist.css in app.module.js so
 * appspace-ui's own overrides still win. vendor.css used to load after it,
 * which is the same inversion that let it override the app's Bootstrap.
 *
 * handsontable and owl-carousel were also in vendor.css. No component in this
 * app renders either, so they are deliberately not restored.
 */
export default [
    {
        name: 'spectrum-colorpicker',
        signature: '.sp-container',
        usedBy: 'asui-dist colour pickers',
        css: require('~/node_modules/spectrum-colorpicker/spectrum.css')
    },
    {
        name: 'froala-editor',
        signature: '.fr-toolbar',
        usedBy: 'asui-rich-text, e.g. #!/support/createcase',
        css: require('~/node_modules/froala-editor/css/froala_editor.pkgd.min.css')
    },
    {
        name: 'intl-tel-input',
        signature: '.iti',
        usedBy: 'asui-tel, used by supportContact',
        css: require('~/node_modules/intl-tel-input/build/css/intlTelInput.min.css')
    },
    {
        name: 'jquery-contextmenu',
        signature: '.context-menu',
        usedBy: 'licenseInstanceDetail',
        css: require('~/node_modules/jquery-contextmenu/dist/jquery.contextMenu.min.css')
    }
];



// WEBPACK FOOTER //
// ./vendorStyles.js